// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3FeNI","name":"styles_name__1zUol","phone":"styles_phone__1xABN"};